import { render, staticRenderFns } from "./UnscheduledExams.view.vue?vue&type=template&id=53fa25a0&scoped=true"
import script from "./UnscheduledExams.view.vue?vue&type=script&lang=js"
export * from "./UnscheduledExams.view.vue?vue&type=script&lang=js"
import style0 from "./UnscheduledExams.view.vue?vue&type=style&index=0&id=53fa25a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fa25a0",
  null
  
)

export default component.exports